import React from 'react'
import styled from 'styled-components'
import { body01Css } from '~/components/common/typography'
import { NoBulletUl } from './styled'

const Container = styled(NoBulletUl)`
  background-color: ${({ theme }) => theme._neo.ui01};
  border-radius: 6px;
  margin-top: 4px;
  padding: 8px 16px;
`

const Item = styled.li`
  ${body01Css}
`

const NameList = ({ items }) =>
  <Container>{items.map(name => <Item key={name}>{name}</Item>)}</Container>

export default NameList
